<template>
  <div class="create-purchase-request">
    <a-spin :spinning="loading">
      <div
        class="content step-content text-link"
        style="min-height: 0"
        v-show="purchaseRequestReadyList.length > 1"
      >
        {{ $t('采购申请单创建进度') }}: {{ currentStep + 1 }} /
        {{ purchaseRequestReadyList.length }}
        <span class="ml20">{{ $t('当前供应商') }}: {{ this.formData.supplierName }}</span>
      </div>
      <div class="content" style="min-height: 0">
        <a-tabs default-active-key="OrderStatusFlow" @change="changeTabs">
          <a-tab-pane
            v-if="isEdit"
            key="OrderStatusFlow"
            :tab="$t(`form.OrderStatusFlow`)"
          ></a-tab-pane>
          <a-tab-pane key="SupplierInfo" :tab="$t(`供应商信息`)"></a-tab-pane>
          <a-tab-pane key="ReceiverInfo" :tab="$t(`收货信息`)"></a-tab-pane>
          <a-tab-pane key="ArrivalDetail" :tab="$t(`采购信息`)"></a-tab-pane>
          <a-tab-pane key="ProductInfo" :tab="$t(`商品信息`)"></a-tab-pane>
        </a-tabs>
      </div>
      <div class="content-overflow mt10">
        <section class="left-div fixContent" :style="{ height: scrollHeight }">
          <a-form-model ref="ruleForm" :model="formData">
            <div v-if="isEdit" id="OrderStatusFlow" class="modalBox">
              <p>
                <i class="leftLine"></i>
                <span style="font-size: 16px; font-weight: 900; color: rgba(0, 0, 0, 0.85)">
                  {{ $t(`订单流转状态`) }}
                </span>
                <a-icon type="sync" class="text-main" @click="refreshHandle" />
              </p>
              <div class="statusBox">
                <p v-show="formData.purchaseRequestSn">
                  {{ $t(`采购申请单号`) }}：{{ formData.purchaseRequestSn }}
                  <a-tag style="font-size: 12px; font-weight: normal; margin-left: 10px">
                    {{ $t(`form.${formData.status}`) }}
                  </a-tag>
                </p>
                <div v-if="!isShow && !isInfoShow">
                  <!-- v-if="getPermission('f_purchase', 'f_purchase_order_audit')" -->
                  <a-button
                    type="primary"
                    :loading="reviewLoading"
                    @click="onReview('firstCheckPurchaseRequest')"
                    v-if="
                      formData.buttons?.checkFirstButton &&
                      getPermission(['f_purchase', 'f_purchase_request', 'f_pr_first_check'])
                    "
                  >
                    {{ $t(`采购主管审核`) }}
                  </a-button>
                  <a-button
                    type="primary"
                    :loading="reviewLoading"
                    @click="onReview('middleCheckPurchaseRequest')"
                    v-if="
                      formData.buttons?.checkMiddleButton &&
                      getPermission(['f_purchase', 'f_purchase_request', 'f_pr_middle_check'])
                    "
                  >
                    {{ $t(`财务审核`) }}
                  </a-button>
                  <a-button
                    type="primary"
                    :loading="reviewLoading"
                    @click="onReview('finalCheckPurchaseRequest')"
                    v-if="
                      formData.buttons?.checkFinalButton &&
                      getPermission(['f_purchase', 'f_purchase_request', 'f_pr_final_check'])
                    "
                  >
                    {{ $t(`CEO审核`) }}
                  </a-button>
                  <a-button
                    v-if="formData.buttons?.rejectButton"
                    type="danger"
                    :loading="voidOrderLoading"
                    @click="onVoidOrder"
                  >
                    {{ $t(`form.Refuse`) }}
                  </a-button>
                </div>
              </div>
              <ProcessState2
                v-if="stateData.length > 0"
                :statedata="stateData"
                :curstate="curState"
                :style-obj="{ stateItem: 130 }"
              />
            </div>
            <div id="SupplierInfo" class="modalBox">
              <div class="infoTitle">
                <div>
                  <i class="leftLine"></i>
                  <span>{{ $t('供应商信息') }}</span>
                  <span>
                    <a
                      style="margin-left: 5px; font-size: 14px"
                      href="javascript:;"
                      v-if="isEdit && !isShow && formData.status === 'WAIT_CHECK'"
                      @click.prevent="isShow = !isShow"
                    >
                      <a-icon type="edit" />
                    </a>
                    <a
                      style="margin: 0 5px; font-size: 14px"
                      href="javascript:;"
                      v-if="isEdit && isShow"
                      @click.prevent="createForm"
                    >
                      <a-icon type="check-circle" style="color: rgb(82, 196, 26)" />
                    </a>
                    <a
                      style="font-size: 14px"
                      href="javascript:;"
                      v-if="isEdit && isShow"
                      @click.prevent="cancelEdit"
                    >
                      <a-icon type="close-circle" />
                    </a>
                  </span>
                  <span>
                    <a style="font-size: 14px; margin-left: 10px" v-if="isCopy" @click="copyOrder">
                      {{ $t(`复制订单`) }}
                    </a>
                  </span>
                </div>
              </div>
              <a-row :gutter="24">
                <a-col :span="8">
                  <a-form-model-item :label="$t(`form.supplierName`)" :required="true">
                    <SelectSupplier
                      :code="formData.supplierCode"
                      :isDisabled="isDisabled || isFromOrder"
                      @supplierIndexChange="supplierIndexChange"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t(`form.OpeningBank`)">
                    <a-input
                      :disabled="true"
                      v-model="formData.openingBank"
                      :placeholder="$t(`form.OpeningBank`)"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t(`form.BankAccount`)">
                    <a-input
                      :disabled="true"
                      v-model="formData.bankAccount"
                      :placeholder="$t(`form.BankAccount`)"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="8">
                  <a-form-model-item :label="$t(`form.ContactInformation`)">
                    <a-input
                      :disabled="true"
                      v-model="formData.supplierMobile"
                      :placeholder="$t(`form.PleaseEnter`) + $t(`form.supplierMobile`)"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t(`form.ShippingAddress`)">
                    <a-input
                      :disabled="true"
                      v-model="formData.supplierAddress"
                      :placeholder="$t(`form.PleaseEnter`) + $t(`form.SupplierShippingAddress`)"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </div>
            <div id="ReceiverInfo" class="modalBox">
              <div class="infoTitle">
                <div>
                  <i class="leftLine"></i>
                  <span>{{ $t('收货信息') }}</span>
                  <span>
                    <a
                      style="margin-left: 5px; font-size: 14px"
                      href="javascript:;"
                      v-if="isEdit && !isShow && formData.status === 'WAIT_CHECK'"
                      @click.prevent="isShow = !isShow"
                    >
                      <a-icon type="edit" />
                    </a>
                    <a
                      style="margin: 0 5px; font-size: 14px"
                      href="javascript:;"
                      v-if="isEdit && isShow"
                      @click.prevent="createForm"
                    >
                      <a-icon type="check-circle" style="color: rgb(82, 196, 26)" />
                    </a>
                    <a
                      style="font-size: 14px"
                      href="javascript:;"
                      v-if="isEdit && isShow"
                      @click.prevent="cancelEdit"
                    >
                      <a-icon type="close-circle" />
                    </a>
                  </span>
                </div>
              </div>
              <a-row :gutter="24">
                <a-col :span="8">
                  <a-form-model-item required :label="$t(`form.receiverWarehouse`)">
                    <SelectWarehouseNew
                      ref="SelectWarehouseRef"
                      :disabled="isDisabled || isFromOrder"
                      :code.sync="formData.warehouseCode"
                      @selected="selectedWarehouse"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item required :label="$t(`仓库货主`)">
                    <SelectWarehouseShipper
                      ref="SelectWarehouseShipperRef"
                      :disabled="isDisabled"
                      :wmsAppCode="wmsAppCode"
                      :code.sync="formData.shipperUniqueCode"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t(`form.receiverName`)">
                    <a-input
                      :disabled="isDisabled"
                      v-model="formData.receiverName"
                      :placeholder="$t(`form.receiverName`)"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="8">
                  <a-form-model-item :label="$t(`form.receiverMobile`)">
                    <a-input
                      :disabled="isDisabled"
                      v-model="formData.receiverMobile"
                      :placeholder="$t(`form.PleaseEnter`) + $t(`form.receiverMobile`)"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t(`form.receiverAddress`)">
                    <a-input
                      :disabled="isDisabled"
                      v-model="formData.receiverAddress"
                      :placeholder="$t(`form.PleaseEnter`) + $t(`form.receiverAddress`)"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </div>
            <div id="ArrivalDetail" class="modalBox">
              <div class="infoTitle">
                <div>
                  <i class="leftLine"></i>
                  <span>{{ $t('form.PurchasingInformation') }}</span>
                  <span>
                    <a
                      style="margin-left: 5px; font-size: 14px"
                      href="javascript:;"
                      v-if="isEdit && !isShow && formData.status === 'WAIT_CHECK'"
                      @click.prevent="isShow = !isShow"
                    >
                      <a-icon type="edit" />
                    </a>
                    <a
                      style="margin: 0 5px; font-size: 14px"
                      href="javascript:;"
                      v-if="isEdit && isShow"
                      @click.prevent="createForm"
                    >
                      <a-icon type="check-circle" style="color: rgb(82, 196, 26)" />
                    </a>
                    <a
                      style="font-size: 14px"
                      href="javascript:;"
                      v-if="isEdit && isShow"
                      @click.prevent="cancelEdit"
                    >
                      <a-icon type="close-circle" />
                    </a>
                  </span>
                </div>
              </div>
              <a-row :gutter="24">
                <!-- <a-col :span="8">
                  <a-form-model-item :label="$t(`form.OrderType`)">
                    <a-select
                      allowClear
                      :placeholder="$t(`form.SelectOrderType`)"
                      style="width: 100%"
                      v-model="formData.purchaseOrderType"
                      :disabled="isDisabled"
                    >
                      <a-select-option key="FIRST_ORDER" value="FIRST_ORDER">
                        {{ $t(`form.FIRST_ORDER`) }}
                      </a-select-option>
                      <a-select-option key="REPEAT_ORDER" value="REPEAT_ORDER">
                        {{ $t(`form.REPEAT_ORDER`) }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col> -->
                <a-col :span="8">
                  <a-form-model-item :label="$t(`form.referenceNo`)">
                    <a-input
                      :disabled="isDisabled"
                      v-model="formData.referenceNo"
                      :placeholder="$t(`form.referenceNo`)"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item>
                    <template template="label">
                      <a-popover placement="topLeft">
                        <template slot="content">
                          {{ $t('下单时间指的是跟供应商线下的下单时间') }}
                        </template>
                        <div style="line-height: normal">
                          {{ $t(`form.OrderDate`) }}
                          <i class="fa-regular fa-circle-question"></i>
                          :
                        </div>
                      </a-popover>
                    </template>
                    <DatePicker
                      :needhms="true"
                      style="background-color: #ffffff; width: 100%"
                      :init-date-time="formData.purchaseOrderTime"
                      @choose="chooseOrderDate"
                      :disabled="isDisabled"
                      :placehold="$t(`form.OrderDate`)"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t(`预计到货时间`)">
                    <DatePicker
                      :needhms="false"
                      style="background-color: #ffffff; width: 100%"
                      :init-date-time="formData.estimatedArrivalTime"
                      @choose="chooseEstimatedArrivalTime"
                      :disabled="isDisabled"
                      :placehold="$t(`预计到货时间`)"
                    />
                  </a-form-model-item>
                </a-col>
              </a-row>

              <a-row :gutter="24">
                <a-col :span="8">
                  <a-form-model-item required :label="$t(`form.ProductTotalAmount`)">
                    <a-input-number
                      style="width: 100%"
                      disabled
                      v-model="formData.orderAmount"
                      :placeholder="$t(`form.SumOfTotalAmountOfGoods`)"
                      @change="inputProductTotalAmountFn"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t(`form.VATRate`)" required>
                    <div class="flex">
                      <a-input-number
                        style="width: 100%; margin-right: 10px"
                        :disabled="isDisabled"
                        v-model="formData.vatRate"
                        :placeholder="$t(`form.PleaseTheNumericalPart`)"
                        @change="inputVATRateFn"
                      />
                      <a-select
                        allowClear
                        :placeholder="$t(`商品采购价是否含税`)"
                        style="width: 100%"
                        v-model="formData.isItemIncludeTax"
                        @change="changeIncludeTax"
                        :disabled="isDisabled"
                      >
                        <a-select-option :value="1">
                          {{ $t(`采购价格含税`) }}
                        </a-select-option>
                        <a-select-option :value="0">
                          {{ $t(`采购价格不含税`) }}
                        </a-select-option>
                      </a-select>
                    </div>
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t(`form.InvoiceType`)">
                    <a-select
                      allowClear
                      :placeholder="$t(`form.InvoiceType`)"
                      style="width: 100%"
                      v-model="formData.invoiceType"
                      :disabled="isDisabled"
                    >
                      <a-select-option key="VAT_INVOICE" value="VAT_INVOICE">
                        {{ $t(`form.VATSpecialInvoice`) }}
                      </a-select-option>
                      <a-select-option key="ORDINARY_INVOICE" value="ORDINARY_INVOICE">
                        {{ $t(`form.OrdinaryInvoice`) }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="8">
                  <a-form-model-item :label="$t(`form.SalesVAT`)">
                    <a-input
                      :disabled="isDisabled"
                      v-model="formData.salesVat"
                      :placeholder="$t(`form.SalesVATCalculation`)"
                      @change="inputSalesVATeFn"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t(`订单总金额（含税）`)">
                    <a-input
                      :disabled="isDisabled"
                      v-model="formData.totalAmount"
                      :placeholder="$t(`商品总金额+销售增值税+其他费用`)"
                      @change="inputTotalOrderAmountFn"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t(`form.PORemarks`)">
                    <a-input
                      :disabled="isEdit && (!isEdit || !isShow)"
                      v-model="formData.note"
                      :placeholder="$t(`form.PORemarks`)"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="16">
                  <a-form-model-item :label="$t(`form.PaymentMethod`)">
                    <div class="flex" style="align-items: center; flex-wrap: wrap">
                      <a-input
                        type="number"
                        style="width: 100px; margin-right: 4px"
                        :disabled="isDisabled"
                        v-model="formData.paymentMethodDeposit"
                      ></a-input>
                      <span>%{{ $t('定金') }}，</span>
                      <a-input
                        type="number"
                        style="width: 100px; margin-right: 4px"
                        :disabled="isDisabled"
                        v-model="formData.paymentMethodBeforeShipment"
                      ></a-input>
                      <span>%{{ $t('出货前支付') }}，</span>
                      <a-input
                        type="number"
                        style="width: 100px; margin-right: 4px"
                        :disabled="isDisabled"
                        v-model="formData.paymentMethodNextMonth"
                      ></a-input>
                      <span>%{{ $t('次月支付') }}</span>
                    </div>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </div>
          </a-form-model>
          <div id="ProductInfo" class="modalBox">
            <div>
              <div class="infoTitle">
                <div>
                  <i class="leftLine"></i>
                  {{ $t('商品信息') }}
                  <span>
                    <a
                      style="margin-left: 5px; font-size: 14px"
                      href="javascript:;"
                      v-if="isEdit && !isInfoShow && formData.status === 'WAIT_CHECK'"
                      @click.prevent="isInfoShow = !isInfoShow"
                    >
                      <a-icon type="edit" />
                    </a>
                    <a
                      style="margin: 0 5px; font-size: 14px"
                      href="javascript:;"
                      v-if="isEdit && isInfoShow && formData.status === 'WAIT_CHECK'"
                      @click.prevent="createInfoForm"
                    >
                      <a-icon type="check-circle" style="color: rgb(82, 196, 26)" />
                    </a>
                    <a
                      style="font-size: 14px"
                      href="javascript:;"
                      v-if="isEdit && isInfoShow && formData.status === 'WAIT_CHECK'"
                      @click.prevent="cancelInfoEdit"
                    >
                      <a-icon type="close-circle" />
                    </a>
                  </span>
                </div>
              </div>
              <div class="pricing-method flex-ct">
                <a-form-model-item :label="$t(`计价方式`)" required>
                  <a-select
                    :disabled="isEdit && !isInfoShow"
                    :placeholder="$t(`请选择计价方式`)"
                    v-model="calculateTypeNew"
                    @change="scrollToBottom"
                    style="width: 300px"
                  >
                    <a-select-option value="BY_TOTAL">
                      {{ $t('通过小计计算单价') }}
                    </a-select-option>
                    <a-select-option value="BY_UNIT">
                      {{ $t('通过单价计算小计') }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </div>
              <a-row
                v-if="!isEdit || (isEdit && isInfoShow)"
                style="display: flex; justify-content: space-between"
              >
                <a-col style="position: relative; flex: 1">
                  <SearchSku style="width: 300px" @selected="handleChangeSku" />
                  <a-button type="primary" style="margin-left: 15px" @click="addGoodsToTable(true)">
                    <i class="icon iconfont icon-new" style="margin-right: 5px"></i>
                    {{ $t('form.Add') }}
                  </a-button>
                  <a-button type="primary" @click="showModal">
                    <i class="icon iconfont icon-new" style="margin-right: 5px"></i>
                    {{ $t(`form.BatchImport`) }}
                  </a-button>
                </a-col>
                <a-col></a-col>
                <a-col>
                  <div class="txt fz16" style="font-weight: bold">
                    <span style="margin-right: 30px">
                      {{ $t('数量合计') }}: {{ purchaseAllQuantity | toThousands }}
                    </span>
                    <span>
                      {{ $t('金额合计') }}: {{ purchaseAllAmount | toThousands }}
                      {{ $t(`form.${tableData[0]?.currency || 'CNY'}`) }}
                    </span>
                  </div>
                </a-col>
              </a-row>
              <a-row>
                <div class="table-wrapper" style="margin-top: 10px">
                  <!--每个列的宽度必须比列名总长度大才能使表格所有列对齐，留一个列不设置宽度  :rowSelection="{selectedRowKeys: selectedRowKeys}"-->
                  <a-table
                    :columns="columns"
                    :dataSource="tableData"
                    bordered
                    size="middle"
                    :loading="tableLoading"
                    :pagination="false"
                    :scroll="{ x: 1500 }"
                    :rowKey="(record, index) => index"
                  >
                    <span slot="Category">
                      {{ $t(`form.Category`) }}
                    </span>
                    <span slot="ProductBarcode">
                      {{ $t(`form.ProductBarcode`) }}
                    </span>
                    <span slot="SkuNumber">
                      {{ $t(`form.skuNumber`) }}
                    </span>
                    <span slot="SupplierModelNumber">
                      {{ $t(`form.SupplierModelNumber`) }}
                    </span>
                    <span slot="CommoditySpecification">
                      {{ $t(`form.CommoditySpecification`) }}
                    </span>
                    <span slot="CompositionMaterial">
                      {{ $t(`form.CompositionMaterial`) }}
                    </span>
                    <span slot="BoxSize" class="form-table-heard">
                      {{ $t(`form.BoxSize`) }}
                    </span>
                    <span slot="Unit">
                      {{ $t(`form.Unit`) }}
                    </span>
                    <span slot="onTheWay">
                      {{ $t(`form.onTheWay`) }}
                    </span>
                    <span slot="RetailPrice">
                      {{ $t(`form.RetailPrice`) }}
                    </span>
                    <span slot="Remark">
                      {{ $t(`form.Remark`) }}
                    </span>
                    <span slot="discountAmountTitle">
                      <a-popover placement="topLeft">
                        <template slot="content">
                          {{ $t('当单价乘以数量与小计不等时展示优惠金额') }}
                        </template>
                        {{ $t(`优惠金额`) }}
                        <i class="fa-regular fa-circle-question"></i>
                      </a-popover>
                    </span>
                    <span slot="PurchasePriceCase" class="form-table-heard">
                      {{ $t(`form.PurchasePriceCase`) }}
                    </span>
                    <span slot="Operation">
                      {{ $t(`form.Operation`) }}
                    </span>
                    <span slot="titleValue" class="form-table-heard">
                      {{ $t('form.TotalQuantity') }}
                    </span>
                    <span slot="titleValue2" class="form-table-heard">
                      {{ $t('form.PurchasePrice') }}
                    </span>
                    <span slot="CurrencyUnit" class="form-table-heard">
                      {{ $t('form.CurrencyUnit') }}
                    </span>
                    <span slot="CasesNumber" class="form-table-heard">
                      {{ $t('form.CasesNumber') }}
                    </span>
                    <span slot="PurchaseAmount" class="form-table-heard">
                      {{ $t('form.PurchaseAmount') }}
                    </span>
                    <span slot="LeadTime">
                      {{ $t('form.LeadTime') }}
                    </span>
                    <span slot="no" slot-scope="text, record, index">
                      {{ index + 1 }}
                    </span>
                    <span slot="productName" slot-scope="text, record">
                      <div v-if="record.productName">{{ $t('名称') }}:{{ record.productName }}</div>
                      <div v-if="record.barcode">{{ $t('条码') }}:{{ record.barcode }}</div>
                      <div v-if="record.skuCode">{{ $t('编码') }}:{{ record.skuCode }}</div>
                    </span>
                    <span slot="unit" slot-scope="text, record">
                      <SelectUnit
                        :disabled="!(!isEdit || (isEdit && isInfoShow))"
                        :skuCode="record.skuCode"
                        :list="record.unitList || record.unitVoList"
                        :code.sync="record.unit"
                      />
                    </span>
                    <span slot="caseNumShow" slot-scope="text, record">
                      <div
                        v-html="generateUnitConversions(record.unitList || record.unitVoList)"
                      ></div>
                    </span>
                    <template slot="productStyle" slot-scope="text">
                      {{ text }}
                    </template>
                    <template v-for="col in customRenderList" v-slot:[col]="text, record, index">
                      <div :key="col">
                        <!-- includes 用来判断当前的输入类型 -->
                        <div v-if="!isEdit || (isEdit && isInfoShow)">
                          <a-input-number
                            :read-only="readonlyArr.includes(col)"
                            :placeholder="$t(`form.PleaseEnter`)"
                            :formatter="Formatter"
                            :parser="Formatter"
                            :disabled="isFromOrder"
                            v-if="col === 'containerQuantity' || col === 'purchaseQuantity'"
                            :value="text"
                            @blur="(e) => handleChange(e.target.value, col, index)"
                          />
                          <a-input-number
                            :read-only="readonlyArr.includes(col)"
                            :placeholder="$t(`form.PleaseEnter`)"
                            :parser="(value) => value.match(/^[0-9]*\.([0-9]{0,4})|^[0-9]*/)[0]"
                            v-else-if="col === 'purchaseUnitPrice'"
                            :disabled="calculateTypeNew === 'BY_TOTAL'"
                            :value="text"
                            @blur="(e) => handleChange(e.target.value, col, index)"
                          />
                          <a-input-number
                            :read-only="readonlyArr.includes(col)"
                            :placeholder="$t(`form.PleaseEnter`)"
                            :parser="(value) => value.match(/^[0-9]*\.([0-9]{0,4})|^[0-9]*/)[0]"
                            v-else-if="col === 'purchaseAmount'"
                            :disabled="calculateTypeNew === 'BY_UNIT'"
                            :value="text"
                            @blur="(e) => handleChange(e.target.value, col, index)"
                          />
                          <a-popover v-else-if="col === 'deliveryTime'" trigger="hover">
                            <template slot="content">
                              <p>{{ $t(`layer.LeadTimeEage`) }}</p>
                            </template>
                            <a-input
                              :read-only="readonlyArr.includes(col)"
                              :placeholder="$t(`form.PleaseEnter`)"
                              :value="text ? text.split(' ')[0] : ''"
                              @change="(e) => handleChange(e.target.value, col, index)"
                            />
                          </a-popover>
                          <a-input
                            :read-only="readonlyArr.includes(col)"
                            :placeholder="$t(`form.PleaseEnter`)"
                            v-else-if="inputScopedSlots.includes(col)"
                            :value="text"
                            @change="(e) => handleChange(e.target.value, col, index)"
                          />
                          <a-select
                            :placeholder="$t(`form.pleaseChoose`)"
                            style="display: block"
                            v-else-if="col === 'currency'"
                            :value="text"
                            @change="handleChange($event, col, index)"
                          >
                            <a-select-option :value="item" v-for="item in currencyMap" :key="item">
                              {{ $t(`form.${item}`) }}
                            </a-select-option>
                          </a-select>
                          <a v-else-if="col === 'delect'" @click="onDelect(index)">
                            <a-icon type="delete" style="color: red" />
                          </a>
                          <span v-else>{{ text | toThousands }}</span>
                        </div>
                        <span v-else-if="col === 'currency'">
                          {{ $t(`form.${text}`) }}
                        </span>
                        <span v-else>{{ text | toThousands }}</span>
                      </div>
                    </template>
                  </a-table>
                </div>
              </a-row>
            </div>
          </div>
        </section>
        <OperationLog :list="orderActions" />
      </div>

      <div class="content" style="min-height: 0" v-if="!isEdit">
        <a-row type="flex" justify="center">
          <a-col>
            <a-row type="flex" justify="start" :gutter="16">
              <a-button type="default" @click="backForm">{{ $t(`form.Back`) }}</a-button>
              <a-button
                v-if="formData.status !== 'FINISH'"
                type="primary"
                @click="onSubmit"
                :loading="submitLoading"
              >
                {{ $t(`form.Save`) }}
              </a-button>
            </a-row>
          </a-col>
        </a-row>
      </div>
    </a-spin>
    <!-- 导入采购商品信息数据 -->
    <a-modal
      class="importModal"
      v-model="isImportData"
      :title="modalInfo.modalTitle"
      :width="500"
      :footer="null"
    >
      <div class="upload-content">
        <a-upload-dragger
          name="file"
          :data="{ buId: buId }"
          :headers="{ Authorization: sessionId }"
          @change="importData"
          :action="modalInfo.modalUrl + `?language=${this.language_mapping[this.lang]}`"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="cloud-upload" />
          </p>
          <p class="ant-upload-hint">{{ $t('form.DragUpload') }}</p>
        </a-upload-dragger>
        <a
          v-if="modalInfo.xlsDownloadUrl"
          class="text-info mt10"
          download
          :href="modalInfo.xlsDownloadUrl"
        >
          {{ $t('采购商品批量录入模版') }}.xls
        </a>
      </div>
    </a-modal>
    <!-- 供价调整弹窗 -->
    <a-modal
      v-model="priceAdjustmentVisible"
      :title="$t('供价调整')"
      :width="800"
      :confirmLoading="priceAdjustmentLoading"
      @ok="updatePurchaseOrderPrice"
    >
      <div class="modal-main-content">
        <a-table
          :columns="priceAdjustmentColumns"
          :data-source="priceAdjustmentData"
          :pagination="false"
          :rowKey="(record, index) => index"
        >
          <span slot="productName" slot-scope="text, record">
            <div v-if="record.productName">{{ $t('名称') }}:{{ record.productName }}</div>
            <div v-if="record.barcode">{{ $t('条码') }}:{{ record.barcode }}</div>
            <div v-if="record.skuCode">{{ $t('编码') }}:{{ record.skuCode }}</div>
          </span>
          <template slot="purchaseUnitPrice" slot-scope="text, record">
            <a-input-number style="width: 120px" v-model="record.purchaseUnitPrice" :min="0" />
          </template>
        </a-table>
      </div>
    </a-modal>
    <!-- 选择商品供应商弹窗 -->
    <a-modal
      :keyboard="false"
      :maskClosable="false"
      v-model="showGoodsSupplierVisible"
      :title="$t('选择商品供应商')"
      :width="800"
      @ok="goToCreatePR"
      @cancel="isFromOrder = false"
    >
      <div class="modal-main-content">
        <a-table
          :columns="productSupplierColumns"
          :data-source="productSupplierData"
          :pagination="false"
          :rowKey="(record, index) => index"
        >
          <span slot="productName" slot-scope="text, record">
            <div v-if="record.skuName">{{ $t('名称') }}:{{ record.skuName }}</div>
            <div v-if="record.barcode">{{ $t('条码') }}:{{ record.barcode }}</div>
            <div v-if="record.skuCode">{{ $t('编码') }}:{{ record.skuCode }}</div>
          </span>
          <template slot="supplier" slot-scope="text, record">
            <SelectSupplier
              :code="formData.supplierCode"
              @supplierIndexChange="
                (val) => {
                  supplierIndexChange2(val, record)
                }
              "
            />
          </template>
        </a-table>
      </div>
    </a-modal>
  </div>
</template>

<script>
import http from '@/service/axios'
import api from '@/service/api'
import SelectSupplier from '@component/selectSupplier'
import { mapState, mapGetters } from 'vuex'
import debounce from '@/common/debounce'
import { add, reserved, divide, multiply } from '@/common/number'
import { getCookie } from '@/common/cookie'
import ProcessState2 from '@component/processState2'
import SearchSku from '@component/searchSku'
import DatePicker from '@component/datePicker'
import formatter from '@/common/formatter'
import deepClone from '@/common/deepClone'
import OperationLog from '@component/operationLog'
import SelectUnit from '@component/selectUnit'
import { getPermission, toFixedUp } from '@/common'
import SelectWarehouseNew from '@component/selectWarehouseNew'
import SelectWarehouseShipper from '@component/selectWarehouseShipper'
export default {
  name: 'CreatePurchaseRequest',
  components: {
    SelectSupplier,
    ProcessState2,
    SearchSku,
    DatePicker,
    OperationLog,
    SelectUnit,
    SelectWarehouseNew,
    SelectWarehouseShipper,
  },
  data() {
    return {
      isCopy: false,
      loading: false,
      isEdit: false, //是否是详情页
      isShow: false, //详情页下 待审核的单子 上面三块的编辑状态
      isInfoShow: false, //详情页下 待审核的单子 商品模块的编辑状态
      purchaseOrderId: '',
      data2: [],
      orderActions: [],
      keyword: '',
      // 表格数据
      tableData: [],
      // 每一列的插槽名 - 表格行内编辑用
      customRenderList: [
        'containerQuantity',
        'caseUnit',
        'purchaseQuantity',
        'purchaseUnitPrice',
        'currency',
        'note',
        'delect',
        'retailPrice',
        'purchaseAmount',
        'deliveryTime',
        // "skuNumber",
      ],
      // 用来匹配插槽中显示input框
      inputScopedSlots: [
        'containerQuantity',
        'purchaseQuantity',
        'purchaseUnitPrice',
        'note',
        'retailPrice',
        'purchaseAmount',
        'deliveryTime',
        'discountAmount',
        // "skuNumber",
      ],
      // 对于某些自动赋值的input框设为 只读
      readonlyArr: [''],
      // 表格loading
      tableLoading: false,
      // 表格选中key
      selectedRowKeys: [],
      provinceList: [],
      formData: {
        purchaseOrderType: undefined,
        warehouseCode: undefined,
        invoiceType: undefined,
        freightInfo: undefined,
        isItemIncludeTax: 0,
        vatRate: 0,
        shipperUniqueCode: undefined,
      },
      selectedGoodsOrGroup: {},
      selectedGoodsOrGroupArray: [],
      currentGood: {},
      data: [],
      selectOptionsLoading: false,
      isImportData: false, //批量导入弹窗
      modalInfo: {
        modalTitle: '',
        modalDesc: '',
        modalUrl: api.batchImportPurchaseOrderItems,
        xlsRequestUrl: '',
        xlsDownloadUrl: '',
      }, //批量导入模板信息
      stateData: [],
      pageNo: 1,
      pageSize: 20,
      pages: '',
      curState: {
        state: 'create',
      },
      language_mapping: {
        zh: 'zh_CN',
        en: 'en_US',
        th: 'th_TH',
      },
      purchaseAllQuantity: 0,
      purchaseAllAmount: 0,
      supplierIndex: undefined,
      submitLoading: false,
      calculateType: 'BY_PCS', //计价方式
      reviewLoading: false,
      confirmFinishLoading: false,
      voidOrderLoading: false,
      priceAdjustmentVisible: false,
      priceAdjustmentLoading: false,
      priceAdjustmentData: [],
      wmsAppCode: undefined,
      calculateTypeNew: 'BY_TOTAL',
      showGoodsSupplierVisible: false,
      productSupplierData: [],

      purchaseRequestReadyList: [], //预创建列表
      currentStep: 0,

      isFromOrder: false,
    }
  },
  activated() {
    if (!this.$route.meta.keepAlive) {
      let data = this.$options.data()
      for (let key in data) {
        this[key] = data[key]
      }
      this.$refs.SelectWarehouseRef.clear()
      this.$refs.SelectWarehouseShipperRef.clear()
    }
    this.init()
    this.getList()

    let orderSns = this.$route.query.orderSns
    //从订单详情页跳转过来的
    if (orderSns) {
      this.isFromOrder = true
      this.getDefaultRelation(orderSns)
    }
    let purchasePlanInfo = localStorage.getItem('purchasePlanInfo')
    //采购计划跳转过来的
    if (purchasePlanInfo) {
      purchasePlanInfo = JSON.parse(purchasePlanInfo)
      this.productSupplierData = purchasePlanInfo
      this.showGoodsSupplierVisible = true
    }
  },
  computed: {
    ...mapState(['currencyMap']),
    ...mapGetters(['isStore']),
    sessionId() {
      return getCookie('d_session_id')
    },
    lang() {
      return this.$store.state.lang
    },
    buId() {
      return this.$store.getters.partyId
    },
    isDisabled() {
      return this.isEdit && (!this.isEdit || !this.isShow || this.formData.status !== 'WAIT_CHECK')
    },
    columns() {
      let list = [
        {
          title: 'NO',
          align: 'center',
          key: 'NO',
          width: 60,
          scopedSlots: {
            customRender: 'no',
          },
        },
        {
          title: this.$t('商品信息'),
          dataIndex: 'productName',
          width: 200,
          scopedSlots: {
            customRender: 'productName',
          },
        },
        {
          slots: { title: 'CommoditySpecification' },
          align: 'center',
          dataIndex: 'productStyle',
          width: 120,
          scopedSlots: {
            customRender: 'productStyle',
          },
        },
        {
          title: this.$t('箱规'),
          align: 'center',
          dataIndex: 'caseNumShow',
          width: 100,
          scopedSlots: {
            customRender: 'caseNumShow',
          },
        },
        {
          align: 'center',
          dataIndex: 'unit',
          width: 100,
          title: this.$t('单位'),
          scopedSlots: {
            customRender: 'unit',
          },
        },
        {
          title: this.$t('数量'),
          align: 'center',
          dataIndex: 'purchaseQuantity',
          width: 120,
          scopedSlots: {
            customRender: 'purchaseQuantity',
          },
        },
        {
          title: this.$t('单价'),
          align: 'center',
          dataIndex: 'purchaseUnitPrice',
          width: 120,
          scopedSlots: {
            customRender: 'purchaseUnitPrice',
          },
        },
        {
          title: this.$t('小计'),
          align: 'center',
          dataIndex: 'purchaseAmount',
          width: 120,
          scopedSlots: {
            customRender: 'purchaseAmount',
          },
        },
        {
          align: 'center',
          dataIndex: 'discountAmount',
          width: 120,
          slots: { title: 'discountAmountTitle' },
          scopedSlots: {
            customRender: 'discountAmount',
          },
        },
        {
          align: 'center',
          dataIndex: 'currency',
          width: 100,
          slots: { title: 'CurrencyUnit' },
          scopedSlots: {
            customRender: 'currency',
          },
        },
        {
          slots: { title: 'SkuNumber' },
          align: 'center',
          dataIndex: 'skuNumber',
          width: 120,
          scopedSlots: {
            customRender: 'skuNumber',
          },
        },
        {
          slots: { title: 'Category' },
          align: 'center',
          dataIndex: 'productCategory',
          width: 120,
          scopedSlots: {
            customRender: 'category',
          },
        },
        {
          slots: { title: 'SupplierModelNumber' },
          align: 'center',
          dataIndex: 'supplierSkuCode',
          width: 120,
          scopedSlots: {
            customRender: 'supplierSkuCode',
          },
        },
        {
          slots: { title: 'CompositionMaterial' },
          align: 'center',
          dataIndex: 'materialQuality',
          width: 120,
          scopedSlots: {
            customRender: 'materialQuality',
          },
        },
        {
          slots: { title: 'Remark' },
          align: 'center',
          dataIndex: 'note',
          width: 120,
          scopedSlots: {
            customRender: 'note',
          },
        },
        {
          slots: { title: 'LeadTime' },
          align: 'center',
          dataIndex: 'deliveryTime',
          width: 120,
          scopedSlots: {
            customRender: 'deliveryTime',
          },
        },
        {
          slots: { title: 'Operation' },
          align: 'center',
          dataIndex: 'delect',
          width: 120,
          scopedSlots: {
            customRender: 'delect',
          },
        },
      ]

      if (this.isEdit && !this.isInfoShow) {
        list.splice(-1, 1, {
          slots: { title: 'onTheWay' },
          align: 'center',
          dataIndex: 'inTransitCount',
          width: 120,
        })
      }
      if (!this.isStore) {
        list.splice(3, 2)
      }
      return list
    },
    priceAdjustmentColumns() {
      return [
        {
          title: this.$t('商品信息'),
          dataIndex: 'productName',
          scopedSlots: {
            customRender: 'productName',
          },
        },
        {
          title: this.$t('单价'),
          dataIndex: 'purchaseUnitPrice',
          scopedSlots: {
            customRender: 'purchaseUnitPrice',
          },
        },
      ]
    },
    productSupplierColumns() {
      return [
        {
          title: this.$t('商品信息'),
          dataIndex: 'productName',
          scopedSlots: {
            customRender: 'productName',
          },
        },
        {
          title: this.$t('采购数量'),
          dataIndex: 'quantity',
        },
        {
          title: this.$t('库存'),
          dataIndex: 'stock',
        },
        {
          title: this.$t('供应商'),
          dataIndex: 'supplier',
          scopedSlots: {
            customRender: 'supplier',
          },
          width: 300,
        },
      ]
    },
    scrollHeight() {
      let height =
        window.innerHeight -
        (this.purchaseRequestReadyList.length > 1 ? 345 : this.isEdit ? 220 : 300)
      return height * this.$store.state.rate + 'px'
    },
  },
  watch: {
    'formData.salesVat': {
      handler() {
        if (this.formData.orderAmount && (this.formData.salesVat || this.formData.salesVat == 0)) {
          this.setTotalAmount()
        }
      },
    },
    'formData.vatRate': {
      handler() {
        if (this.formData.orderAmount && (this.formData.salesVat || this.formData.salesVat == 0)) {
          this.setTotalAmount()
        }
      },
    },
  },
  methods: {
    Formatter: formatter,
    getPermission,
    init() {
      this.isShow = false
      this.currentStep = 0
      this.purchaseRequestReadyList = []
      this.productSupplierData = []
    },
    changeIncludeTax(val) {
      if (val) {
        this.formData.orderAmount = reserved(
          this.purchaseAllAmount / (1 + (this.formData.vatRate || 0) / 100)
        )
        this.formData.salesVat = reserved(this.purchaseAllAmount - this.formData.orderAmount)
      } else {
        this.formData.salesVat = (
          (this.purchaseAllAmount * (this.formData.vatRate || 0)) /
          100
        ).toFixed(4)
        this.formData.orderAmount = this.purchaseAllAmount
      }
      this.setTotalAmount()
    },
    refreshHandle() {
      this.getList()
    },
    scrollToBottom() {
      this.$nextTick(() => {
        document.querySelector('.fixContent').scrollTo(0, 2000)
      })
    },
    setTotalAmount() {
      let otherFees = this.formData.otherFees
      otherFees = otherFees === undefined ? 0 : this.formData.otherFees * 1
      let result = this.formData.orderAmount * 1 + this.formData.salesVat * 1 + otherFees
      this.formData.totalAmount = isNaN(result) ? '' : result.toFixed(4)
    },
    supplierIndexChange(val) {
      this.formData.supplierName = val.supplierName
      this.formData.supplierCode = val.supplierCode
      this.formData.supplierAddress = val.supplierAddress
      this.formData.supplierMobile = val.supplierMobile
      this.formData.bankAccount = val.bankAccount
      this.formData.openingBank = val.openingBank
      this.$forceUpdate()
    },
    supplierIndexChange2(val, record) {
      this.$set(record, 'supplierData', val)
      this.$set(record, 'supplierName', val.supplierName)
      this.$set(record, 'supplierCode', val.supplierCode)
    },
    async getList() {
      this.loading = true
      this.isCopy = false
      this.isEdit = false
      let purchaseFormdata = localStorage.getItem('purchaseFormdata')
      if (this.$route.query.id) {
        this.isCopy = true
        this.purchaseOrderId = this.$route.query.id
        this.isEdit = true
        let res = await http({
          url: api.queryPurchaseRequestDetail,
          type: 'post',
          data: {
            id: this.purchaseOrderId,
          },
        })
        let goodsList = res.result.purchaseOrderItemResVOS.sort((a, b) => {
          a.skuNumber - b.skuNumber
        })
        goodsList.forEach((goodsItem) => {
          goodsItem.unit = goodsItem.caseUnit
        })
        this.tableData = goodsList
        let formData = res.result
        formData.isItemIncludeTax = +formData.isItemIncludeTax
        this.formData = formData
        this.calculateType = formData.calculateType
        this.keyword = ''
        this.$forceUpdate()
        this.getOrderProcess()
        this.calcAllAmount()
        this.getOrderActionList()
      } else if (purchaseFormdata) {
        let data = JSON.parse(purchaseFormdata)
        console.log(data)
        this.formData = data
        this.formData.status = ''
        this.tableData = deepClone(this.formData.tableData)
        delete this.formData.tableData
        localStorage.removeItem('purchaseFormdata')
      }
      this.loading = false
    },
    createForm() {
      let formData = deepClone(this.formData)
      http({
        url: api.updatePurchaseRequestBaseInfo,
        type: 'post',
        data: {
          id: this.formData.purchaseOrderId,
          ...formData,
        },
        hasLoading: false,
        success: () => {
          this.getList()
          this.$forceUpdate()
          this.isShow = !this.isShow
        },
      })
    },
    async createInfoForm() {
      await this.verification()
      await http({
        url: api.updatePurchaseRequestItems,
        type: 'post',
        data: {
          calculateType: this.calculateType,
          orderAmount: this.formData.orderAmount,
          salesVat: this.formData.salesVat,
          totalAmount: this.formData.totalAmount,
          purchaseRequestId: this.purchaseOrderId,
          purchaseOrderItemReqVOS: this.tableData,
        },
        hasLoading: false,
      })
      this.getList()
      this.isInfoShow = !this.isInfoShow
    },
    cancelEdit() {
      this.getList()
      this.isShow = !this.isShow
    },
    cancelInfoEdit() {
      this.getList()
      this.isInfoShow = !this.isInfoShow
    },
    getOrderActionList() {
      http({
        url: api.queryCommonActionList,
        type: 'post',
        data: {
          actionCategory: 'purchase_request',
          actionSn: this.formData.purchaseRequestSn,
        },
        hasLoading: false,
        success: (res) => {
          this.orderActions = res.result
        },
      })
    },
    chooseEstimatedArrivalTime(data) {
      this.formData.estimatedArrivalTime = data.data
    },
    chooseOrderDate(data) {
      this.formData.purchaseOrderTime = data.data
    },
    handleChangeSku(data) {
      this.currentGood = data
    },
    handleChange(value, colName, index) {
      const newData = [...this.tableData]
      const target = newData[index]
      if (target) {
        target[colName] = value
        this.calcPurchaseAmount(colName)
        this.tableData = newData
      }
    },
    calcPurchaseAmount(colName) {
      this.getTheAmountInPcFn(colName)
      this.calcAllAmount()
    },
    calcAllAmount() {
      let quantity = 0,
        amount = 0
      this.tableData.forEach((item) => {
        quantity = add(quantity, item.purchaseQuantity)
        amount = add(amount, item.purchaseAmount)
      })
      this.purchaseAllQuantity = quantity
      this.purchaseAllAmount = amount
    },
    onDelect(index) {
      this.tableData.splice(index, 1)
      this.$nextTick(() => {
        this.calcPurchaseAmount()
      })
    },
    addGoodsToTable(bol = true) {
      if (this.currentGood.skuName) {
        this.currentGood.productCategory =
          this.currentGood.categoryName || this.currentGood.category //类目
        this.currentGood.productName = this.currentGood.skuName
        this.currentGood.skuNumber = this.currentGood.brandSku //品牌款号
        this.currentGood.supplierSkuCode = this.currentGood.supplierSku //供应商款号
        this.currentGood.productStyle = this.currentGood.skuStyleValue
        this.currentGood.materialQuality = this.currentGood.compositionOrMaterial //成分材质
        let procurementUnitItem =
            this.currentGood.unitList?.find((item) => item.procurementUnit) || {},
          baseUnitItem = this.currentGood.unitList?.find((item) => item.baseUnit) || {}
        this.currentGood.unit =
          procurementUnitItem.unitNameFull || baseUnitItem.unitNameFull || this.currentGood.unit
        this.currentGood.currency = 'CNY'
        this.currentGood.editable = true
        if (
          this.tableData.length &&
          this.tableData.findIndex((i) => i.barcode == this.currentGood.barcode) !== -1
        ) {
          return this.$message.error(this.$t('form.DoNotAddRepeatedly'))
        }
        this.tableData.push(this.currentGood)
        bol && this.scrollToBottom()
      }
    },
    // 以pc获取金额
    getTheAmountInPcFn() {
      if (!this.tableData.length) return
      let hasEmpty = false
      let sum = 0
      this.tableData.forEach((item) => {
        if (item.purchaseQuantity && (item.purchaseUnitPrice || item.purchaseAmount)) {
          //修改单价和数量 小计跟着改
          if (this.calculateTypeNew === 'BY_TOTAL') {
            item.purchaseUnitPrice = toFixedUp(
              divide(item.purchaseAmount, item.purchaseQuantity),
              4
            )
          } else {
            item.purchaseAmount = multiply(item.purchaseUnitPrice, item.purchaseQuantity).toFixed(4)
          }
          sum += item.purchaseAmount * 1

          let calTotalAmount = item.purchaseQuantity * item.purchaseUnitPrice
          item.discountAmount = (calTotalAmount - item.purchaseAmount).toFixed(4)
        } else {
          hasEmpty = true
        }
      })
      if (hasEmpty) return
      if (this.formData.isItemIncludeTax) {
        this.formData.orderAmount = reserved(sum / (1 + (this.formData.vatRate || 0) / 100))
        this.formData.salesVat = reserved(sum - this.formData.orderAmount)
      } else {
        this.formData.salesVat = ((sum * (this.formData.vatRate || 0)) / 100).toFixed(4)
        this.formData.orderAmount = sum.toFixed(4)
      }
      this.setTotalAmount()
    },
    // 输入增值税率
    inputVATRateFn() {
      let result = 0
      if (this.formData.isItemIncludeTax) {
        this.formData.orderAmount = reserved(
          this.purchaseAllAmount / (1 + this.formData.vatRate / 100)
        )
        result = reserved(this.purchaseAllAmount - this.formData.orderAmount)
      } else {
        result = ((this.purchaseAllAmount * this.formData.vatRate) / 100).toFixed(4)
      }
      this.formData.salesVat = isNaN(result) ? '' : result
      this.setTotalAmount()
    },
    // 输入其他费用
    inputOtherFeesFn() {
      let result =
        this.formData.orderAmount * 1 + this.formData.salesVat * 1 + this.formData.otherFees * 1
      this.formData.totalAmount = isNaN(result) ? '' : result
    },
    // 输入商品总金额
    inputProductTotalAmountFn(val) {
      let tempObj = { ...this.formData }
      tempObj.totalAmount = val.target.value
      this.formData = { ...tempObj }
      let result = ((this.purchaseAllAmount * this.formData.vatRate) / 100).toFixed(4)
      this.formData.salesVat = isNaN(result) ? '' : result
      let results = this.formData.orderAmount * 1 + this.formData.salesVat * 1
      this.formData.totalAmount = isNaN(results) ? '' : results.toFixed(4)
    },
    // 输入销售增值税
    inputSalesVATeFn(val) {
      let tempObj = { ...this.formData }
      tempObj.salesVat = val.target.value
      this.formData = { ...tempObj }
    },
    // 输入订单总金额
    inputTotalOrderAmountFn(val) {
      let tempObj = { ...this.formData }
      tempObj.totalAmount = val.target.value
      this.formData = { ...tempObj }
    },
    // onEdit() {
    //   this.isEdit = false
    //   this.tableData.forEach((item) => {
    //     item.editable = true
    //   })
    // },
    verification() {
      this.tableData.forEach((res) => {
        if (!res.purchaseQuantity) {
          this.$warning({
            title: this.$t(`layer.Warning`),
            content: this.$t(`layer.PleaseQuantity`),
          })
          throw Error()
        }
        // if (res.purchaseUnitPrice < 0 || !res.purchaseUnitPrice) {
        //   this.$warning({
        //     title: this.$t(`layer.Warning`),
        //     content: this.$t(`layer.PleasePurchasePrice`),
        //   })
        //   throw Error()
        // }
        // if (!res.purchaseAmount) {
        //   this.$warning({
        //     title: this.$t(`layer.Warning`),
        //     content: this.$t(`layer.PleasePurchaseAmount`),
        //   })
        //   throw Error()
        // }
        if (res.deliveryTime && !/^\d{4}\-\d{2}\-\d{2}$/.test(res.deliveryTime)) {
          this.$warning({
            title: this.$t(`layer.Warning`),
            content: this.$t(`layer.FormatOfLeadTime`),
          })
          throw Error()
        }
      })
      return Promise.resolve()
    },
    onSubmit: debounce(async function () {
      if (!this.formData.supplierName) {
        this.$warning({
          title: this.$t(`layer.Warning`),
          content: this.$t(`layer.PleaseSupplier`),
        })
        return
      }
      if (!this.formData.warehouseCode) {
        this.$warning({
          title: this.$t(`layer.Warning`),
          content: this.$t(`layer.PleaseReceivingWarehouse`),
        })
        return
      }
      if (this.formData.vatRate === undefined || this.formData.vatRate === null) {
        this.$warning({
          title: this.$t(`layer.Warning`),
          content: this.$t(`请填写增值税税率`),
        })
        return
      }
      if (this.tableData.length === 0) {
        this.$warning({
          title: this.$t(`layer.Warning`),
          content: this.$t(`请添加商品`),
        })
        return
      }
      await this.verification()
      if (this.purchaseOrderId) {
        this.updatePurchaseRequestBaseInfo(this.formData)
        this.updatePurchaseRequestItems()
      } else {
        let currentShop = JSON.parse(localStorage.getItem('currentShop'))
        if (currentShop === undefined || currentShop === null || currentShop === '') {
          this.$warning({
            title: this.$t(`layer.Warning`),
            content: this.$t(`layer.NoOwnerInformation`),
          })
          return
        }
        const data = deepClone(this.formData)
        data.shopCode = currentShop.uniqueCode
        data.buId = this.$store.getters.partyId
        data.calculateType = this.calculateType
        data.purchaseOrderItemReqVOS = this.tableData
        data.purchaseOrderId = this.purchaseOrderId
        data.isItemIncludeTax = Boolean(data.isItemIncludeTax)
        this.submitLoading = true
        await http({
          url: api.savePurchaseRequest,
          data: { list: [data] },
          type: 'post',
          hasLoading: true,
          success: (res) => {
            if (res.success) {
              if (
                this.purchaseRequestReadyList.length === 0 ||
                this.currentStep + 1 === this.purchaseRequestReadyList.length
              ) {
                this.$success({
                  title: this.$t(`layer.Success`),
                  content: this.$t(`layer.CreateSuccess`),
                })
                this.formData = {}
                this.tableData = []
                this.backForm()
              } else {
                this.tableData = []
                this.$success({
                  title: this.$t(`layer.Success`),
                  content: this.$t(`供应商X采购单创建成功,继续创建下一个供应商的采购单`, {
                    X: this.formData.supplierName,
                  }),
                })
                ++this.currentStep
                this.setInfo()
              }
            } else {
              this.$error({
                title: this.$t(`layer.Error`),
                content: this.$t(`layer.CreateFailed`),
              })
            }
          },
        })
        this.submitLoading = false
      }
    }),
    updatePurchaseRequestBaseInfo(data) {
      data.id = this.purchaseOrderId
      http({
        url: api.updatePurchaseRequestBaseInfo,
        data,
        type: 'post',
        hasLoading: true,
        success: (res) => {
          if (res.success) {
            this.$success({
              title: this.$t(`layer.Success`),
              content: this.$t(`layer.SavingSucceeded`),
            })
          } else {
            this.$error({
              title: this.$t(`layer.Error`),
              content: this.$t(`layer.CreateFailed`),
            })
          }
          this.getOrderActionList()
        },
      })
    },
    updatePurchaseRequestItems() {
      http({
        url: api.updatePurchaseRequestItems,
        data: {
          purchaseRequestId: this.purchaseOrderId,
          purchaseOrderItemReqVOS: this.tableData,
        },
        type: 'post',
        hasLoading: true,
        success: (res) => {
          if (res.success) {
            this.$success({
              title: this.$t(`layer.Success`),
              content: this.$t(`layer.SavingSucceeded`),
            })
          } else {
            this.$error({
              title: this.$t(`layer.Error`),
              content: this.$t(`layer.CreateFailed`),
            })
          }
          this.getOrderActionList()
        },
      })
    },
    handleOk() {
      this.visible = false
      this.$router.push({
        path: '/addAdvancedShippingNote',
        query: {
          purchaseOrderId: this.purchaseOrderId,
        },
      })
    },
    async onReview(name) {
      let url = api[name]
      this.reviewLoading = true
      await http({
        url,
        data: {
          id: this.purchaseOrderId,
        },
        type: 'post',
        hasLoading: true,
        success: (res) => {
          if (res.success) {
            this.$success(this.$t('审核成功'))
            this.getList()
          } else {
            this.$error({
              title: this.$t(`layer.Error`),
              content: this.$t(`layer.CreateFailed`),
            })
          }
        },
      })
      this.reviewLoading = false
    },
    async onVoidOrder() {
      this.voidOrderLoading = true
      await http({
        url: api.rejectPurchaseRequest,
        data: {
          id: this.purchaseOrderId,
        },
        type: 'post',
        hasLoading: true,
        success: (res) => {
          if (res.success) {
            this.getOrderProcess()
            this.$success({
              title: this.$t(`layer.Success`),
              content: this.$t(`layer.OrderVoided`),
            })
            this.$route.params.status = 'Cancel'
            this.backForm()
          } else {
            this.$error({
              title: this.$t(`layer.Error`),
              content: this.$t(`layer.CreateFailed`),
            })
          }
          this.getOrderActionList()
        },
      })
      this.voidOrderLoading = false
    },
    backForm() {
      this.$router.push({ name: 'purchaseRequest' })
    },
    // 数组对象根据barcode去重方法
    arrayUnique(arr, barcode) {
      var hash = {}
      return arr.reduce(function (acc, cru, index) {
        if (!hash[cru[barcode]]) {
          hash[cru[barcode]] = { index: index }
          acc.push(cru)
        } else {
          acc.splice(hash[cru[barcode]]['index'], 1, cru)
        }
        return acc
      }, [])
    },
    showModal() {
      this.isImportData = true
      this.modalInfo.xlsDownloadUrl =
        this.$i18n.locale == 'zh'
          ? 'https://geez-prod.oss-cn-shanghai.aliyuncs.com/template/purchaseOrder/%E6%89%B9%E9%87%8F%E5%AF%BC%E5%85%A5%E9%87%87%E8%B4%AD%E5%8D%95%E6%98%8E%E7%BB%86%E6%A8%A1%E6%9D%BF20230411.xlsx'
          : this.$i18n.locale == 'en'
          ? 'https://geez-prod.oss-cn-shanghai.aliyuncs.com/template/purchaseOrder/PurchaseOrderDetailBatchImportTemplate202304112.xlsx'
          : this.$i18n.locale == 'th'
          ? 'https://geez-prod.oss-cn-shanghai.aliyuncs.com/template/purchaseOrder/PurchaseOrderDetailBatchImportTemplate202304112.xlsx'
          : ''
    },
    // 导入商品信息数据
    importData(info) {
      this.loading = true
      const status = info.file.status
      if (status === 'done') {
        if (info.file.response.success) {
          // 导入的数据
          let resultArr = info.fileList[info.fileList.length - 1].response.result.items
          let sum = 0
          resultArr.forEach((item) => {
            if (!item.purchaseAmount) {
              item.purchaseAmount = multiply(item.purchaseUnitPrice, item.purchaseQuantity).toFixed(
                4
              )
            }
            sum += item.purchaseAmount * 1
          })
          // push到表格列表中
          this.tableData.push(...resultArr)
          let newData = [...this.tableData]
          this.tableData = [...this.arrayUnique(newData, 'barcode')]
          this.formData.purchaseOrderItemReqVOS = this.tableData
          this.isInfoShow = true
          this.formData.orderAmount = sum.toFixed(4)
          let results = ((sum.toFixed(4) * this.formData.vatRate) / 100).toFixed(4)
          this.formData.salesVat = isNaN(results) ? '' : results
          let result = this.formData.orderAmount * 1 + this.formData.salesVat * 1
          this.formData.totalAmount = isNaN(result) ? '' : result.toFixed(4)
          this.$success({
            title: this.$t(`layer.Success`),
            content: `${info.file.name} file uploaded successfully.`,
          })
          this.$nextTick(() => {
            this.loading = false
            this.calcPurchaseAmount()
            this.scrollToBottom()
          })
        } else {
          this.$error({
            title: this.$t(`layer.Error`),
            content: `${info.file.response.msg} file upload failed.`,
          })
          this.loading = false
        }
      } else if (status === 'error') {
        this.$error({
          title: this.$t(`layer.Error`),
          content: `${info.file.name} file upload failed.`,
        })
        this.loading = false
      }
      this.isImportData = false
    },
    getOrderProcess() {
      this.stateData = [
        {
          state: 'create',
          name: 'Create', //创建
          time: this.formData.orderTime,
        },
        {
          state: 'WAIT_FIRST_CHECK',
          name: '采购主管审核',
          time: undefined,
        },
        {
          state: 'WAIT_MIDDLE_CHECK',
          name: '财务审核',
          time: undefined,
        },
        {
          state: 'WAIT_FINAL_CHECK',
          name: 'CEO审核',
          time: undefined,
        },
      ]

      if (this.formData.status === 'PASS') {
        this.stateData.push({
          state: 'check',
          name: '审核通过',
          time: this.formData.status == undefined ? '' : this.formData.checkTime,
        })
        this.curState = {
          state: 'check',
        }
      } else if (this.formData.status === 'REJECT') {
        this.stateData.splice(1, 3, {
          state: 'reject',
          name: 'Rejected',
        })
        this.curState = {
          state: 'reject',
        }
      } else {
        let index = this.stateData.findIndex((item) => item.state === this.formData.status)
        this.curState = {
          state: this.stateData[index - 1]?.state,
        }
      }
    },
    changeTabs(value) {
      document.querySelector(`#${value}`).scrollIntoView(true)
    },
    copyOrder() {
      this.formData.tableData = this.tableData
      let data = JSON.stringify(this.formData)
      localStorage.setItem('purchaseFormdata', data)
      let routeData = this.$router.resolve({
        path: '/createPurchaseRequest',
      })
      window.open(routeData.href, '_blank')
    },
    showPriceAdjustmentModal() {
      this.priceAdjustmentVisible = true
      this.priceAdjustmentData = deepClone(this.tableData)
    },
    async updatePurchaseOrderPrice() {
      this.priceAdjustmentLoading = true
      await http({
        url: api.updatePurchaseOrderPrice,
        data: {
          purchaseOrderId: this.$route.query.id,
          items: this.priceAdjustmentData.map((item) => ({
            barcode: item.barcode,
            purchaseUnitPrice: item.purchaseUnitPrice,
          })),
        },
      })
      this.$message.success(this.$t('操作成功'))
      this.priceAdjustmentVisible = false
      this.priceAdjustmentLoading = false
      this.getList()
    },
    generateUnitConversions(unitList) {
      const conversions = []
      unitList?.forEach((unit) => {
        unitList.forEach((otherUnit) => {
          if (unit.conversionRate > otherUnit.conversionRate) {
            const conversion = `${unit.conversionRate / otherUnit.conversionRate}${
              otherUnit.unitNameFull
            }/${unit.unitNameFull}`
            conversions.push(conversion)
          }
        })
      })
      return conversions.join('<br />')
    },
    selectedWarehouse(data) {
      this.wmsAppCode = data?.wmsAppCode
      this.formData.warehouseCode = data?.uniqueCode
    },
    async getDefaultRelation(orderSns) {
      // 第一步：查订单详情页拿到商品barcodeList
      let res = await http({
        url: api.getOrderGoodsInfo,
        data: {
          orderSnList: orderSns.split(','),
          merchantCode: this.$store.state.userSession.merchantCode,
        },
      })
      this.formData.warehouseCode = res.result.warehouseUniqueCode
      this.productSupplierData = res.result.list
      let barcodeList = res.result.list.map((item) => item.barcode)
      // 第二步：查商品对应的供应商
      let res2 = await http({
        url: api.getDefaultRelation,
        data: {
          barcodeList,
        },
      })
      let supplierGoodsMapping = res2.result.list
      // console.log('supplierGoodsMapping: ', supplierGoodsMapping)
      this.productSupplierData.forEach((item) => {
        let supplierGoodsInfo = supplierGoodsMapping.find((elem) => elem.barcode === item.barcode)
        if (supplierGoodsInfo) {
          this.$set(item, 'supplierCode', supplierGoodsInfo.supplierCode)
          this.$set(item, 'supplierName', supplierGoodsInfo.supplierName)
        }
      })
      this.showGoodsSupplierVisible = true
      // 第三步：查商品对应的库存
      http({
        url: api.skuStockQuerySkuStock,
        type: 'post',
        data: {
          warehouseCode: res.result.warehouseUniqueCode,
          platform: res.result.platform,
          barcodeList,
        },
        success: (res3) => {
          this.productSupplierData.forEach((item) => {
            item.stock = res3.result[item.barcode]?.availableQuantity || 0
          })
        },
      })
    },
    goToCreatePR() {
      let data = {}
      let errMsg
      this.productSupplierData.forEach((item) => {
        if (!item.supplierCode) {
          errMsg = item.skuName + this.$t('商品请选择供应商')
        } else {
          if (data[item.supplierCode]) {
            data[item.supplierCode].skuList.push(item)
          } else {
            data[item.supplierCode] = {
              skuList: [item],
              ...item.supplierData,
            }
          }
        }
      })
      if (errMsg) {
        return this.$message.warning(errMsg)
      }
      // console.log(Object.values(data))
      this.purchaseRequestReadyList = Object.values(data)
      this.currentStep = 0
      this.setInfo()
      this.showGoodsSupplierVisible = false
    },
    setInfo() {
      let data = this.purchaseRequestReadyList[this.currentStep]
      this.supplierIndexChange(data)
      data.skuList.forEach((item) => {
        let purchaseQuantity = item.quantity - item.stock
        item.unitList = []
        item.purchaseQuantity = purchaseQuantity < 0 ? undefined : purchaseQuantity
        this.handleChangeSku(item)
        this.addGoodsToTable(false)
        if (item.warehouseCode) {
          this.formData.warehouseCode = item.warehouseCode
        }
        if (item.vatRate) {
          this.formData.vatRate = item.vatRate
        } else {
          this.formData.vatRate = undefined
        }
      })
      this.$forceUpdate()
    },
  },
}
</script>

<style lang="scss" scoped>
.statusBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.form-table-heard:before {
  content: '*';
  color: red;
}

.form-content {
  padding: 20px 5%;
}
.ant-form-item {
  margin-bottom: 0;
}
.search-group {
  display: flex;
  align-items: center;
  position: relative;
  margin-top: 3px;
  .add {
    position: absolute;
    display: block;
    right: -45px;
  }
}
.goods-list {
  flex-wrap: wrap;
  .goods-item {
    line-height: normal;
    margin-right: 6px;
    margin-bottom: 4px;
    white-space: nowrap;
  }
}
.infoTitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.fixContent {
  padding-top: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 0;
}
.node-modal {
  font-size: 15px;
  padding-top: 10px;
  text-align: center;
}
.content-overflow {
  width: 100%;
  overflow: auto;
  display: flex;
}
.left-div {
  flex: 1;
}
.right-div {
  background-color: transparent;
  font-size: 12px;
  width: 300px;
  height: 591px;
  overflow: auto;
}
.formContentGoods {
  /* padding: 10px 15px; */
  margin-bottom: 16px;
  background-color: white;
  color: #333333;
  font-size: 14px;
}
.modalA :deep(.ant-modal-footer) {
  border-top: 0px solid #e8e8e8;
}
.modalBox {
  margin-bottom: 10px;
  background-color: white;
  padding: 10px;
  border-radius: 5px;
}
.inputMody {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-variant: tabular-nums;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  display: inline-block;
  width: 100%;
  height: 32px;
  padding: 4px 11px;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  line-height: 1.5;
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  transition: all 0.3s;
  outline: none;
}
.inputMody::-webkit-input-placeholder {
  color: #ccc;
}
.pricing-method {
  margin-bottom: 10px;
}
</style>
